import { apiRequest } from '@/utils/api-request';
import { Dataset } from '@/types/source-types';
import { useOrgStore } from '@/stores/org-store';

interface GetDatasetResponse {
  dataset: Dataset;
}

export const getDataset = async (collectionId: string, datasetId: string) => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;

  if (!orgId) {
    throw new Error('Organization ID is required');
  }

  const response = await apiRequest<GetDatasetResponse>({
    url: `/collections/${orgId}/${collectionId}/datasets/${datasetId}`,
    method: 'GET',
    target: 'platform',
  });

  if (response?.detail) {
    return {
      detail: response.detail || 'Failed to fetch dataset',
    };
  }

  return response?.data?.dataset;
};
